import { TokenTypeHint } from 'types/api/b2ciam';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchRevokeTokensOptions = {
  accessToken: string;
  idTokens: string[];
  ignoreAccessToken?: boolean;
};

type TokenConfig = {
  request_mode?: string;
  token?: string;
  token_type_hint: TokenTypeHint;
};

export async function fetchRevokeAllTokens({
  accessToken,
  idTokens,
  ignoreAccessToken
}: FetchRevokeTokensOptions): FetchResponse<void> {
  const tokens: TokenConfig[] = [
    {
      request_mode: 'urn:ext:oauth:request-mode:cookie',
      token_type_hint: 'urn:ext:oauth:token-type-hint:remember_me'
    }
  ];

  if (!ignoreAccessToken) {
    tokens.push({
      request_mode: 'urn:ext:oauth:request-mode:authorization',
      token_type_hint: 'access_token'
    });
  }

  tokens.push({
    request_mode: 'urn:ext:oauth:request-mode:cookie',
    token_type_hint: 'urn:ext:oauth:token-type-hint:activity_ref'
  });

  tokens.push({
    request_mode: 'urn:ext:oauth:request-mode:cookie',
    token_type_hint: 'urn:ext:oauth:token-type-hint:activity_ref_ssi'
  });

  idTokens.forEach(token => {
    tokens.push({
      token,
      token_type_hint: 'urn:ext:oauth:token-type-hint:id_token'
    });
  });

  return fetchReq({
    body: {
      tokens: tokens.map((token, i) => ({
        ref: i + 1,
        ...token
      }))
    },
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    mark: 'revoke_all_tokens',
    method: 'POST',
    url: `${endpoints.token.revoke}/collection`
  });
}

type FetchRevokeIdTokensOptions = {
  accessToken: string;
  idTokens: string[];
  mark: string;
};

export async function fetchRevokeIdTokens({
  accessToken,
  idTokens,
  mark
}: FetchRevokeIdTokensOptions): FetchResponse<void> {
  return fetchReq({
    body: {
      tokens: idTokens.map((token, i) => ({
        ref: i + 1,
        token,
        token_type_hint: 'urn:ext:oauth:token-type-hint:id_token'
      }))
    },
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    mark,
    method: 'POST',
    url: `${endpoints.token.revoke}/collection`
  });
}
